// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__uXMgk","item":"PaymentsMobile_item__1wRKS","label":"PaymentsMobile_label__DPtQ8","amount":"PaymentsMobile_amount__2Jh_M"};